module.exports = __webpack_public_path__ + "img/tipBanner.11a329c8.jpg";